module.exports = __webpack_public_path__ + "static/media/report_feedback_dude3.d0a0ff7e.png";